import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import viewUtil from '../lib/viewUtil';
import './Player.css';

const Player = ({ index, playerData, handleContractUpdate, dirtyData, canUpdate }) => {
    const [contractYears, updateContractYears] = useState(playerData.contract || 0);
    const [showFTPopover, setShowFTPopover] = useState(false);
    const popoverRef = useRef(null);
    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popoverRef.current && !popoverRef.current.contains(event.target)) {
                setShowFTPopover(false);
            }
        };

        if (showFTPopover) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showFTPopover]);
    
    const _handleContractUpdate = (e) => {
        updateContractYears(e.target.value);
        handleContractUpdate(playerData.id, e.target.value);
    }
    
    const toggleFTPopover = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowFTPopover(!showFTPopover);
    }
    
    const ContractEdit = ({ contractYears, onChange}) => (
        <select className="form-select form-select-sm lv-2" value={contractYears} onChange={onChange}>
            <option value='4'>4</option>
            <option value='3'>3</option>
            <option value='2'>2</option>
            <option value='1'>1</option>
            <option value='0'>0</option>
        </select>
    );
    const isExpiring = (!playerData.franchisetag && !contractYears) || contractYears < 1;
    let cardClassName = 'card text-white mb-2 player-card';

    if (dirtyData) {
        cardClassName += ' player-card-dirty';
    }
    if (isExpiring) {
        cardClassName += ' player-card-expiring';
    }
    if (playerData.injured) {
        cardClassName += ' player-card-injured';
    }

    const age = viewUtil.getAge(playerData.birthdate);

    return (
        <div id={'playerRow-' + playerData.id} className={cardClassName}>
            <div className="card-body py-2 px-3 d-flex justify-content-between align-items-start flex-wrap">
                <div className="d-flex align-items-start">
                    <span className="text-muted small me-2">{index + 1}</span>
                    <div>
                        <div>
                            <Link className="player-link" to={`/player/${playerData.id}`}>{playerData.name}</Link>
                            {playerData.franchisetag && (
                                <span
                                    ref={popoverRef}
                                    className="badge bg-info text-dark ms-2 position-relative"
                                    style={{ cursor: 'pointer' }}
                                    onClick={toggleFTPopover}
                                    title="Click for franchise tag details"
                                >
                                    <i className="bi bi-star-fill"></i> FT
                                    {showFTPopover && (
                                        <span
                                            className="position-absolute top-100 start-50 translate-middle-x mt-2 p-2 bg-dark text-white rounded shadow"
                                            style={{
                                                fontSize: '0.875rem',
                                                whiteSpace: 'nowrap',
                                                zIndex: 1050,
                                                minWidth: '150px'
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <div className="fw-bold mb-1">Franchise Tag: {playerData.franchisetag}</div>
                                            <div
                                                className="position-absolute top-0 start-50 translate-middle-x"
                                                style={{
                                                    width: 0,
                                                    height: 0,
                                                    borderLeft: '6px solid transparent',
                                                    borderRight: '6px solid transparent',
                                                    borderBottom: '6px solid #212529',
                                                    marginTop: '-6px'
                                                }}
                                            />
                                        </span>
                                    )}
                                </span>
                            )}
                            {playerData.injured && (
                                <span className="badge bg-danger ms-2" title="Injured">
                                    <i className="bi bi-bandaid-fill"></i> IR
                                </span>
                            )}
                            {isExpiring && (
                                <span className="badge bg-warning text-dark ms-2" title="Contract Expiring">
                                    <i className="bi bi-exclamation-triangle-fill"></i>
                                </span>
                            )}
                        </div>
                        <div className="text-muted small mt-1">
                            {playerData.posname} · {playerData.nflteam} · Age {age ?? '--'}
                            {playerData.yahooleaguerank ? ` · Y!${playerData.yahooleaguerank}` : ''}
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center mt-2 mt-sm-0">
                    {canUpdate ?
                        <ContractEdit contractYears={contractYears} onChange={_handleContractUpdate}></ContractEdit>
                        :
                        <span style={{marginRight: '2px'}}>{contractYears}</span>
                    }
                </div>
            </div>
        </div>
    );
};

export default Player;